import { z } from 'zod'
import { Id, Timestamp } from './common'

export const ExportKind = z.enum(['service_history', 'security_record'])
export type ExportKind = z.infer<typeof ExportKind>
export const ExportState = z.enum(['pending', 'ready', 'failed'])
export type ExportState = z.infer<typeof ExportState>

/** What the rider chose to include. Location is never included, whatever is set here. */
export const ServiceHistoryOptions = z.object({
  /** The frame number helps a buyer check the bike is not stolen. Off unless chosen. */
  include_serial: z.boolean().default(false),
  include_costs: z.boolean().default(true),
})
export type ServiceHistoryOptions = z.infer<typeof ServiceHistoryOptions>

/** `kind` defaults to the service history; its options are ignored for other kinds. */
export const CreateExportBody = ServiceHistoryOptions.partial().extend({
  kind: ExportKind.default('service_history'),
})
export type CreateExportBody = z.input<typeof CreateExportBody>

export const Export = z.object({
  id: Id,
  bike_id: Id,
  kind: ExportKind,
  state: ExportState,
  /** Short-lived download link, once ready. */
  download_url: z.string().nullable(),
  filename: z.string(),
  size_bytes: z.number().nullable(),
  error: z.string().nullable(),
  created_at: Timestamp,
  completed_at: Timestamp.nullable(),
})
export type Export = z.infer<typeof Export>
